var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qiyu-customer-service"},[(_vm.initError)?_c('div',{staticClass:"qiyu-error"},[_c('p',[_vm._v("客服系统暂时不可用")])]):(_vm.isInitializing)?_c('div',{staticClass:"qiyu-loading"},[_c('p',[_vm._v("正在初始化客服系统...")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }